import {userConstants} from '../constants'
import {anonAPI} from '../services/api'

export function registerAction (form, onError) {
  return dispatch => {
    dispatch(request({form}))  // could be removed
    anonAPI.post('/auth/signup', form)
      .then(response => {
        const {data} = response
        dispatch(success(data.token))
      })
      .catch(error => {
        onError(error)
        dispatch(failure(error))
      })
  }

  function request (user) {
    return {type: userConstants.REGISTER_REQUEST, user}
  }

  function success (token) {
    return {type: userConstants.REGISTER_SUCCESS, token}
  }

  function failure (error) {
    return {type: userConstants.REGISTER_FAILURE, error}
  }
}



// WEBPACK FOOTER //
// ./src/actions/registration.action.js